import React, { useEffect, useRef, useState } from 'react';
import { myAccountStyle as styles } from './myAccount.tailwind';
import TabsSection from './shared/Tabs/TabsSection';
import myAccountTabData, { MY_ACCOUNT_TABS } from './myAccountTabsData';
import RedeemRewardsSection from './Sections/RedeemRewardsSection/RedeemRewardsSection';
import ViewGamesSection from './Sections/ViewGamesSection/ViewGamesSection';
import EarnedPointsSection from './Sections/EarnedPointsSection/EarnedPointsSection';
import { connect, useSelector } from 'react-redux';
import { setMyAccountActiveTab } from '../../redux/slices/publicSlice';
import { PAYMENT_STATUS } from '../../lib/constants/globalConstant';
import PaymentModalForBuyPoints from '../shared/Modals/PaymentModalForBuyPoints/PaymentModalForBuyPoints';
import { useLocation, useNavigate } from 'react-router-dom';
import routeConstant from '../../lib/constants/routeConstant';
import Banner from './Sections/Banner/Banner';
import SignUpUpdatesModal from '../shared/Modals/RedeemRewardsModals/SignUpUpdatesModal/SignUpUpdatesModal';
import CoinsPaymentStatusModal from '../shared/Modals/CoinsPaymentStatusModal/CoinsPaymentStatusModal';
 
const MyAccount = ({ setActiveTab }) => {
  const navigate = useNavigate();
  const paymentRef = useRef(false)
  // FOR DEMO
  const location = useLocation();
  const paymentStatusOfTokens = location.state?.paymentStatus || null;
  
  const { MY_ACCOUNT_TAB: activeTab } = useSelector(state => state.public)
  const { currentSeason } = useSelector((state) => state.seasons);
  const { user } = useSelector((state) => state.user);
  const userDetails = user?.userDetails;
  
  const [isModalVisible, setModalVisible] = useState(false); // to open/close modal
  const [paymentStatus, setPaymentStatus] = useState(null);  // to hightlight error or success
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [open, setOpen] = useState(false); // Sign-Up Updates Modal
  
  // FOR DEMO
  const [paymentStatusModal, setPaymentStatusModal] = useState(false)
  useEffect(()=> {
    if(paymentStatusOfTokens === PAYMENT_STATUS.SUCCEDED){
      setPaymentStatusModal(true);     
      navigate('', { replace: true, state: {} });
    }    
  },[])
  

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseModal = async () => {
    setModalVisible(false); // Close modal
    setPaymentStatus(null); // Reset status
    navigate(routeConstant.MY_ACCOUNT_PAGE)
  };

  const handleOpenModal = async (redirectStatus) => {
    setPaymentStatus(redirectStatus === 'succeeded' ? PAYMENT_STATUS.SUCCEDED : PAYMENT_STATUS.FAILED);
    setModalVisible(true);  // open modal
  }

  // Payment Success/ Failure Redirection for purchasing points
  useEffect(() => {    
    const queryParams = new URLSearchParams(window.location.search);
    
    const paymentIntent = queryParams.get('payment_intent');   // Payment Intent
    const redirectStatus = queryParams.get('redirect_status'); // Succeeded or Failed
    setPaymentIntent(paymentIntent); // update payment intent
    
    // window.history.replaceState({}, document.title, window.location.pathname); // [This line is to change route]
    if (paymentIntent) {
      handleOpenModal(redirectStatus);
    }else{
      paymentRef.current = true;
    }
  }, []);

  // FOR DEMO COMMENTED LINES 101-113

  return (
    <section className={styles.container}>
      <Banner />

      <div className='relative'>
        {/* All Tabs Section */}
        <div className='flex items-center justify-between w-full'>
          <TabsSection
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabsData={myAccountTabData}
          />

          {/* Sign Up For Updates */}
          {(!userDetails?.optInForUpdateEmail && activeTab === MY_ACCOUNT_TABS.REDEEM_REWARDS) && (
              <span className={styles.signUp}>
                <span className={styles.link} onClick={handleOpen}>
                  Sign Up
                </span>{" "}
                here to get notified when new rewards become available
              </span>
            )
          }
          {activeTab === MY_ACCOUNT_TABS.VIEW_GAMES && currentSeason?.homeTeam?.teamName && (
            <div className={styles.selectivetabcontent}>
              {/* <div className={styles.home_team_info}>
                <span className={styles.team_text}>Home Team:</span>
                {currentSeason?.homeTeam?.teamImage && (
                  <img
                    src={currentSeason?.homeTeam?.teamImage}
                    alt={currentSeason?.homeTeam?.teamName}
                    className={styles.home_team_icon}
                  />
                )}
                <span className={styles.team_name}>
                  {currentSeason?.homeTeam?.teamName}
                </span>
              </div> */}
            </div>
          )}
        </div>
 
        {/* Section based on Tabs */}
        {/* Redeem Rewards */}
        {activeTab === MY_ACCOUNT_TABS.REDEEM_REWARDS && (
          <RedeemRewardsSection />
        )}

        {/* Earn Points */}
        {activeTab === MY_ACCOUNT_TABS.EARN_POINTS && (
          <EarnedPointsSection />
        )}
  
        {/* View and Live Game(s) */}
        {activeTab === MY_ACCOUNT_TABS.VIEW_GAMES && (
          <ViewGamesSection />
        )}
  
        {/* Dashboard Section */}
        {/* {activeTab === MY_ACCOUNT_TABS.DASHBOARD_TAB && (
          <DashboardSection
            setActiveTab={setActiveTab}
          />
        )} */}
      </div>

      {isModalVisible && (
        <PaymentModalForBuyPoints
          isOpen={isModalVisible}
          onClose={handleCloseModal}
          paymentIntent={paymentIntent}
          status={paymentStatus === PAYMENT_STATUS.SUCCEDED ? PAYMENT_STATUS.SUCCEDED : PAYMENT_STATUS.FAILED}
        />
      )}

      {/* Sign Up for Updates Modal */}
      <SignUpUpdatesModal isOpen={open} onClose={handleClose} />

      {/* FOR DEMO */}
      {paymentStatusModal &&
        <CoinsPaymentStatusModal
          isOpen={paymentStatusModal}
          onClose={() => setPaymentStatusModal(false)}
          status={PAYMENT_STATUS.SUCCEDED}
        />
      }
    </section>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (data) => dispatch(setMyAccountActiveTab(data)),
});

export default connect(null, mapDispatchToProps)(MyAccount);